import React from "react";

interface AddEditProductModalProps {
  isOpen: boolean;
  onClose: () => void;
  editingProduct: Record<string, any> | null;
  formData: {
    name: string;
    upc: string;
    certificate_type: string;
    status: "active" | "inactive";
  };
  formErrors: Record<string, string>;
  saving: boolean;
  handleInputChange: (field: string, value: string) => void;
  handleSaveProduct: () => void;
  onAddProduct?: (product: any) => void; // ✅ optional prop for AskRexi extracted products
}

const AddEditProductModal = (props: AddEditProductModalProps) => {
  const {
    isOpen,
    onClose,
    editingProduct,
    formData,
    formErrors,
    saving,
    handleInputChange,
    handleSaveProduct,
    onAddProduct,
  } = props;

  if (!isOpen) return null;

  return (
    <div className="data-modal-overlay" onClick={onClose}>
      <div className="data-modal" onClick={(e) => e.stopPropagation()}>
        <div className="data-modal-header">
          <h2 className="data-modal-title">
            {editingProduct ? "Product Details" : "Add New Product"}
          </h2>
          <button className="modal-close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="data-modal-body">
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">
                UPC Code <span className="required-indicator">*</span>
              </label>
              <input
                type="text"
                className="form-input"
                placeholder="Enter UPC code"
                value={formData.upc}
                onChange={(e) => handleInputChange("upc", e.target.value)}
              />
              {formErrors.upc && (
                <div className="form-error">{formErrors.upc}</div>
              )}
            </div>

            <div className="form-group">
              <label className="form-label">
                Product Name <span className="required-indicator">*</span>
              </label>
              <input
                type="text"
                className="form-input"
                placeholder="Enter product name"
                value={formData.name}
                onChange={(e) => handleInputChange("name", e.target.value)}
              />
              {formErrors.name && (
                <div className="form-error">{formErrors.name}</div>
              )}
            </div>

            <div className="form-group">
              <label className="form-label">
                Certificate Type <span className="required-indicator">*</span>
              </label>
              <select
                className="form-select"
                value={formData.certificate_type}
                onChange={(e) =>
                  handleInputChange("certificate_type", e.target.value)
                }
              >
                <option value="CPC">CPC</option>
                <option value="GCC">GCC</option>
              </select>
              {formErrors.certificate_type && (
                <div className="form-error">{formErrors.certificate_type}</div>
              )}
            </div>

            <div className="form-group">
              <label className="form-label">Status</label>
              <select
                className="form-select"
                value={formData.status}
                onChange={(e) => handleInputChange("status", e.target.value)}
              >
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>
          </div>
        </div>

        <div className="data-modal-footer">
          <button
            className="modal-btn modal-btn-cancel"
            onClick={onClose}
            disabled={saving}
          >
            Cancel
          </button>
          <button
            className="modal-btn modal-btn-save"
            onClick={async () => {
              await handleSaveProduct();
              if (onAddProduct && formData.name?.trim()) {
                onAddProduct({
                  name: formData.name,
                  upc: formData.upc,
                  certificate_type: formData.certificate_type,
                  status: formData.status,
                  source: "user",
                });
              }
              onClose();
            }}
            disabled={saving}
          >
            {saving
              ? "Saving..."
              : editingProduct
              ? "Update Product"
              : "Add Product"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddEditProductModal;
